module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/AlertCircle.d83877e3.svg";